(function (exports) {
	var MS_IN_MINUTES = 60 * 1000;

	var formatTime = function (date) {
		return date.toISOString().replace(/-|:|\.\d+/g, '');
	};

	var calculateEndTime = function (event) {
		return event.end ?
			formatTime(event.end) :
			formatTime(new Date(event.start.getTime() + (event.duration * MS_IN_MINUTES)));
	};

	var calendarGenerators = {
		google: function (event) {
			var startTime = formatTime(event.start);
			var endTime = calculateEndTime(event);

			var href = encodeURI([
				'https://www.google.com/calendar/render',
				'?action=TEMPLATE',
				'&text=' + (event.title || ''),
				'&dates=' + (startTime || ''),
				'/' + (endTime || ''),
				'&details=' + (event.description || ''),
				'&location=' + (event.address || ''),
				'&sprop=&sprop=name:'
			].join(''));
			return '<a target="_blank" href="' +
				href + '"><i class="fa fa-google" aria-hidden="true"></i>Google</a>';
		},
		
		ics: function (event, eClass, calendarName) {
			var startTime = formatTime(event.start);
			var endTime = calculateEndTime(event);

			var href = encodeURI(
				'data:text/calendar;charset=utf8,' + [
					'BEGIN:VCALENDAR',
					'VERSION:2.0',
					'BEGIN:VEVENT',
					'URL:' + document.URL,
					'DTSTART:' + (startTime || ''),
					'DTEND:' + (endTime || ''),
					'SUMMARY:' + (event.title || ''),
					'DESCRIPTION:' + (event.description || ''),
					'LOCATION:' + (event.address || ''),
					'END:VEVENT',
					'END:VCALENDAR'].join('\n'));

			return '<span class="add-to-calendar__divider">|</span><a class="' + eClass + '" target="_blank" href="' +
				href + '"><i class="fa fa-calendar" aria-hidden="true"></i>' + calendarName + '</a>';
		},

		ical: function (event) {
			return this.ics(event, 'icon-ical', 'iCal');
		},

		outlook: function (event) {
			return this.ics(event, 'icon-outlook', 'Outlook');
		}
	};

	var generateCalendars = function (event) {
		return {
			google: calendarGenerators.google(event),
			outlook: calendarGenerators.outlook(event),
			ical: calendarGenerators.ical(event)
		};
	};

	// Create CSS
	var addCSS = function () {
		if (!document.getElementById('ouical-css')) {
			document.getElementsByTagName('head')[0].appendChild(generateCSS());
		}
	};

	var generateCSS = function () {
		var styles = document.createElement('style');
		styles.id = 'ouical-css';

		return styles;
	};

	// Make sure we have the necessary event data, such as start time and event duration
	var validParams = function (params) {
		return params.data !== undefined && params.data.start !== undefined &&
			(params.data.end !== undefined || params.data.duration !== undefined);
	};

	var generateMarkup = function (calendars, clazz, calendarId) {
		var result = document.createElement('div');

		Object.keys(calendars).forEach(function (services) {
			result.innerHTML += calendars[services];
		});

		result.className = 'add-to-calendar';
		if (clazz !== undefined) {
			result.className += (' ' + clazz);
		}

		addCSS();

		result.id = calendarId;
		return result;
	};

	var getClass = function (params) {
		if (params.options && params.options.class) {
			return params.options.class;
		}
	};

	var getOrGenerateCalendarId = function (params) {
		return params.options && params.options.id ?
			params.options.id :
			Math.floor(Math.random() * 1000000); // Generate a 6-digit random ID
	};

	exports.createCalendar = function (params) {
		if (!validParams(params)) {
			console.log('Event details missing.');
			return;
		}

		return generateMarkup(generateCalendars(params.data),
			getClass(params),
			getOrGenerateCalendarId(params));
	};
})(window);

const calendarButtons = document.querySelectorAll('.js-calendar-button');

if (calendarButtons && calendarButtons.length) {
	// for calendar elements z-index is always over 9000
	let indexNum = 9001 + calendarButtons.length;
	calendarButtons.forEach(function (element) {
		--indexNum;
		const calendarButton = createCalendar({
			options: {
				class: 'js-calendar-button-' + element.getAttribute('data-id'),
				id: 'js-calendar-button-' + element.getAttribute('data-id')
			},
			data: {
				// Event title
				title: element.getAttribute('data-title'),

				// Event start date
				// start: new Date('June 15, 2013 19:00'),
				start: new Date(element.getAttribute('data-start')),

				// Event duration (IN MINUTES)
				duration: element.getAttribute('data-duration') || 60,

				// You can also choose to set an end time
				// If an end time is set, this will take precedence over duration
				end: element.getAttribute('data-end') ? new Date(element.getAttribute('data-end')) : null,

				// Event Address
				address: element.getAttribute('data-address'),

				// Event Description
				description: element.getAttribute('data-description')
			}
		});
		element.setAttribute('style', 'z-index: ' + indexNum);
		element.appendChild(calendarButton);
	});
}